const styles = {
  formSelect: {
    borderRadius: '.25rem !important',
    borderColor: '#dddddd !important',
    margin: '.25rem .25rem !important',
    fontSize: '.800rem !important',
    padding: '0 !important',

    '& div': {
      color: '#787878 !important',
      borderRadius: '.25rem !important',

      '&.ui.selection.active.dropdown': {
        borderColor: '#ddd !important',
        borderRadius: '.2857rem !important',
        boxShadow: 'none !important',

        '&:hover': {
          borderColor: '#ddd !important',
        },

        '& .menu': {
          boxShadow: '0 .125rem .375rem 0 rgba(0, 0, 0, 0.05) !important',
          border: 'solid .0625rem rgba(0, 0, 0, 0.03) !important',
          borderRadius: '.2857rem !important',
          marginTop: '.5rem',
        },

        '&.upward .menu': {
          marginBottom: '.5rem',
        },
      },

      '&.ui.selection.dropdown': {
        backgroundColor: '#fff !important',
        minHeight: 'auto !important',
        padding: '.5rem !important',
        minWidth: '8rem !important',

        '& .dropdown.icon': {
          top: '.5em',
        },

        '& .menu': {
          '& .item': {
            fontSize: '.875rem !important',
            border: 'none !important',

            '&.selected': {
              backgroundColor: '#fff !important',

              '& span': {
                color: '#683caf !important',
              },
            },

            '&:hover': {
              backgroundColor: 'transparent !important',
            },
          },
        },
      },
    },
  },
};

export default styles;
